import * as React from 'react';
import { buttonGroupStyle as style } from './style';
export const ButtonGroup = (props) => {
    const css = style;
    return React.createElement("div", { className: css }, props.children);
};
//# sourceMappingURL=ButtonGroup.js.map